import { Routes, Route, Navigate } from 'react-router-dom'

import LoginPage from '../pages/auth/LoginPage'
import HomePage from '../pages/home/HomePage'

import AdminLayout from '../layouts/AdminLayout'
import InstitutionLayout from '../layouts/InstitutionLayout'
import ProctorLayout from '../layouts/ProctorLayout'

import AdminDashboard from '../pages/admin/Dashboard'
import InstitutionDashboard from '../pages/institution/Dashboard'
import ProctorDashboard from '../pages/proctor/Dashboard'
import { jwtDecode } from 'jwt-decode'
import ExamRoom from '../pages/exam/ExamRoom'
import ExamRegistration from '../pages/exam/ExamRegistration'
import ExamStart from '../pages/exam/ExamStart'
import ExamQuestions from '../pages/exam/ExamQuestions'
import ExamResult from '../pages/exam/ExamResult'
import OnlyWebView from '../pages/exam/OnlyWebView'

export default function AppRoutes() {
   const PrivateRoute = ({ children, role }) => {
      const token = sessionStorage.getItem('token')
      let userRole = null

      if (token) {
         try {
            const decoded = jwtDecode(token)
            userRole = decoded.role
         } catch (err) {
            console.error('Invalid token', err)
         }
      }

      if (!token) {
         console.warn('there is no token')
         return <Navigate to="/login" replace />
      }

      if (role && userRole !== role) {
         console.warn('role doesnt match with page accessed')
         return <Navigate to="/login" replace />
      }

      return children
   }

   const PrivateRouteExam = ({ children, role }) => {
      const token = sessionStorage.getItem('exam_token')

      if (!token) {
         console.warn('there is no token')
         return <>Please Register First!</>
      }

      return children
   }

   return (
      <Routes>
         <Route path="/" element={<HomePage />} />
         <Route path="/login" element={<LoginPage />} />
         <Route path="/exam" element={<ExamRoom />} />
         <Route path="/exam/registration" element={<ExamRegistration />} />
         <Route path="/exam/only_web_view" element={<OnlyWebView />} />

         <Route
            path="/admin"
            element={
               <PrivateRoute role="admin">
                  <AdminLayout />
               </PrivateRoute>
            }
         >
            <Route path="dashboard" element={<AdminDashboard />} />
         </Route>

         <Route
            path="/institution"
            element={
               <PrivateRoute role="institution">
                  <InstitutionLayout />
               </PrivateRoute>
            }
         >
            <Route path="dashboard" element={<InstitutionDashboard />} />
         </Route>

         <Route
            path="/proctor"
            element={
               <PrivateRoute role="proctor">
                  <ProctorLayout />
               </PrivateRoute>
            }
         >
            <Route path="dashboard" element={<ProctorDashboard />} />
         </Route>

         <Route
            path="/exam/start"
            element={
               <PrivateRouteExam>
                  <ExamStart />
               </PrivateRouteExam>
            }
         ></Route>
         <Route
            path="/exam/questions"
            element={
               <PrivateRouteExam>
                  <ExamQuestions />
               </PrivateRouteExam>
            }
         ></Route>
         <Route
            path="/exam/result"
            element={
               <PrivateRouteExam>
                  <ExamResult />
               </PrivateRouteExam>
            }
         ></Route>
      </Routes>
   )
}
